import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { palette } from '../../../palette';

const DialogTitle = ({ children, onClose, ...other }) => (
    <MuiDialogTitle sx={{ m: 0, p: 2 }} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }} onClick={onClose}>
                <CloseIcon />
            </IconButton>
        ) : null}
    </MuiDialogTitle>
);

const DialogContent = (props) => <MuiDialogContent {...props} sx={{ p: 2, ...props.sx }} />;
const DialogActions = (props) => <MuiDialogActions {...props} sx={{ m: 0, p: 1, ...props.sx }} />;

export default function CustomDialog(props) {
    //const dialogTitle = props.dialogInfo.dialogTitle;
    //const dialogMessage = props.dialogInfo.dialogMessage;
    const dialogTitle = props.dialogTitle;
    const dialogMessage = props.dialogMessage;
    return (
        <div>
        <Dialog onClose={props.onClose} aria-labelledby="customized-dialog-title" open={props.open}>
            <DialogTitle id="customized-dialog-title" onClose={props.onClose}>
                {dialogTitle}
            </DialogTitle>
            <DialogContent dividers>
            <Typography gutterBottom>
                {dialogMessage}
            </Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={props.onClose} style={{ color: palette.greys.medium }}>
                    Close
                </Button>
                {props.dialogAction && <Button autoFocus onClick={props.dialogAction} style={{ color: palette.primary.main }}>
                    Confirm
                </Button>}
            </DialogActions>
        </Dialog>
        </div>
    );
}